.form-input__container {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}

.form-input__container--label-left {
  align-items: flex-start;
  flex-direction: row;
  gap: 1rem;
  line-height: 2.5rem;
}

.form-input__container--label-left > label::after {
  line-height: 3.6;
}

.form-input__container--label-top {
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
  line-height: normal;
}

.form-input__input-feedback-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;
  line-height: 1.5;
  position: relative;
  width: 100%;
}

.form-input__input-container {
  display: flex;
  flex: 1;
}

.form-input__input {
  appearance: none;
  background-color: transparent;
  border: 1px solid;
  border-radius: 0.5rem;
  color: var(--color-uva-black);
  flex: 1;
  font-family: inherit;
  font-size: inherit;
  height: 2.75rem;
  min-height: 2.5rem;
  padding: 0 1rem;
  text-align: inherit;
}

.form-input__input::-webkit-outer-spin-button,
.form-input__input::-webkit-inner-spin-button {
  margin: 0;
}

.form-input__input.not-valid {
  border-color: var(--color-red-600);
}
